
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useGetOrganisationsQuery } from 'services/organisations';

import "./organisation_select.scss"

// Shared react-select styling for the Carbon-styled filter selects. Also
// reused by the location filter (see components/Location/LocationSelection)
// so both dropdowns look identical.
export const customStyles = {
  option: (provided, _state) => ({
    ...provided,
  }),
  container: (provided, _state) => ({
    ...provided,
    '&:focus': {
      borderColor: "var(--cds-focus, #0099bb)",
      borderWidth: "2px"
    },
  }),
  control: (provided, _state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    borderRadius: 0,
    border: 0,
    backgroundColor: "#f4f4f4",
    borderBottom: "1px solid var(--cds-border-strong)",
    '&:focus': {
      borderColor: "var(--cds-focus, #0099bb)",
      borderWidth: "2px"
    },
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

const SelectableOrganisation = ({selection = [], onSelectionChange = () => {}, asFilter = false, isMulti = false, forUsers = false, forLocations = false}) => {

  const [currentSelection, setSelection] = useState([]);
  const {data: organisations, isLoading} = useGetOrganisationsQuery({onlyWithUsers: forUsers, onlyWithLocations: forLocations});

  useEffect(() => {
    setSelection(selection);
  }, [selection]);

  const handleSelectionChange = (new_selection, action ) => {
    if (action.action === "clear") {
      onSelectionChange([]);
      return;
    }
    let new_selection_ids = Array.isArray(new_selection) ? new_selection.map(e => e.value) : [new_selection.value];
    onSelectionChange(new_selection_ids);
  };

  return (
    <Select
      className="micast-wall--select"
      isClearable={asFilter}
      onSelectResetsInput={asFilter}
      isMulti={isMulti}
      classNames={{
        control: (state) => 'micast-wall--select-control'
      }}
      placeholder={asFilter ? "Nach Organisation filtern..." : "Organisation auswählen..."}
      noOptionsMessage={() => "Wählen Sie"}
      isLoading={isLoading}
      styles={customStyles}
      isOptionDisabled={(organisation) => (asFilter && forUsers && organisation.count_users === 0) || (asFilter && forLocations && organisation.count_locations === 0)}
      onChange={handleSelectionChange}
      options={(organisations || []).map(organisation => { return {label: organisation?.name?.length === 0 ? `--kein Name-- id:${organisation.id}` : organisation.name, value: organisation.id, count_users: organisation.count_users, count_locations: organisation.count_locations} })}
      value={(currentSelection || []).map(current_id => {
        if (organisations && current_id > 0) {
          const f = organisations.find(organisation => current_id === organisation.id);
          return {label: f.name, value: f.id, count_users: f.count_users, count_locations: f.count_locations}
        }
        return null;
      })}
    />
  )
}

export default SelectableOrganisation;
